import { Model as s } from "../../../../../model.js";
class t extends s {
  constructor(o) {
    super(), this.id = o.id, this.url = o.url, this.token = o.token;
  }
}
export {
  t as ShopSessionShopModel
};
//# sourceMappingURL=shop.model.js.map
